import {useCallback, useContext, useEffect, useState} from "react";
import {Checkbox, CheckboxContext} from "../../shopdrawing/Checkbox";
import {Popover} from "../../../../misc/Popover";
import {Button, useTheme} from "@mui/material";
import {KeyboardArrowDown} from "@mui/icons-material";

export function MultiSelectRowHeader(props: {
    children: (close: () => void, ids: number[], reset:() => void) => JSX.Element;
    inline?: boolean;
}) {
    const ctx = useContext(CheckboxContext);
    const {selectAll, listenAll, reset} = ctx;

    const [selected, setSelected] = useState<number[]>([]);
    const [selectAllToggle, setSelectAllToggle] = useState(false);

    useEffect(() => {
        const sub = listenAll(setSelected);
        return () => sub.cancel();
    }, [listenAll]);

    const [showMore, setShowMore] = useState<HTMLElement|null>(null);
    const close = useCallback(() => setShowMore(null), []);
    const theme = useTheme();
    const color = selected.length > 0 ? theme.palette.primary.contrastText : theme.palette.text.primary

    return (
        <div style={Object.assign({display: "flex", alignItems: "center",
            color: color,
        },
            selected.length > 0 ? {
                backgroundColor: theme.palette.primary.main,
                position: "absolute", top: 0, left: 0, right: 0, bottom: 0, paddingLeft: 8, paddingRight: 16,
                zIndex: 10,
            }
                : {}) as any}>
            <Checkbox size="small" checked={selectAllToggle} onClick={() => {
                if(selectAllToggle) {
                    reset();
                } else {
                    selectAll(true);
                }

                setSelectAllToggle(!selectAllToggle);
            }} style={{color: color}} />

            {selected.length > 0 && <div style={{flex: 1, paddingLeft: 8, display: "flex", alignItems: "center"}}>
                <div>{selected.length} items selected</div>

                <div style={{flex: 1}} />

                {props.inline ? <>
                    {props.children(close, selected, reset)}
                </> : <Button variant="outlined" size="small" style={{
                    color: "white",
                    borderColor: "white",
                }} onClick={e => setShowMore(e.currentTarget)} endIcon={<KeyboardArrowDown />}>
                    Bulk Action
                </Button>}

                {showMore && <Popover
                    open={true}
                    anchorEl={showMore}
                    onClose={() => setShowMore(null)}
                >
                    <div style={{height: 4}} />
                    {props.children(close, selected, reset)}
                    <div style={{height: 4}} />
                </Popover>}
            </div>}
        </div>
    )
}